import styled from 'styled-components';
import avatarSara from 'assets/images/sara.png';
import avatarApp from 'assets/images/app.svg';
import { colors, fonts } from 'styles';
import { File } from 'styles/styled-components';

export { ButtonMiniVariant } from 'styles/styled-components';

const red500 = '#ef4444';

export const TestEnvWarning = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
  background-color: ${red500};
  color: white;
  font-size: 14px;
  line-height: 20px;
  width: 100%;
`;

export const Container = styled.main`
  display: flex;
  width: 100%;
  height: 100vh;
  background: linear-gradient(
	112.46deg,
	${colors.gray} 3.3%,
	${colors.gray2} 100.38%
  );
`;

export const Content = styled.section`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 99;

  .siteBlindado {
	position: absolute;
	bottom: 48px;
	left: 48px;
	z-index: 1;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  column-gap: 64px;
  width: max-content;
  padding: 40px;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.white};
  border-radius: 6px;
  padding: 56px 16px 16px 16px;
  margin-bottom: 16px;
  width: min-content;
  box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.15);
`;

export const AvatarSara = styled.img.attrs({ src: avatarSara })`
  width: 40px;
  margin-top: -70px;
`;

export const AvatarApp = styled.img.attrs({ src: avatarApp })`
  width: 80px;
  margin-top: -90px;
`;

export const Name = styled.span`
  display: block;
  padding: 8px 0;
  font-size: 14px;
  font-family: ${fonts.GilroyBold};
  color: ${colors.dark};
`;

export const Text = styled.article`
  font-family: ${fonts.OpenSans};
  font-size: 12px;
  line-height: 18px;
  color: ${colors.white};
  text-align: center;
  max-width: 224px;
`;

export const BtnFileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  top: 48px;
  right: 48px;
  z-index: 1;
`;

export const IconFile = styled(File).attrs({ size: 20 })`
  margin-right: 8px;
  color: ${colors.dark};
`;
